import { api } from './index';

export type TherapeuticLoadRow = {
  career: string;
  humanCareer: string;
  // Visits the requirements prescribe (Acordado)
  agreed: number;
  // Visits the weekly plans place in the month, plus biweekly/monthly requirements (Presupuestado)
  budgeted: number;
  // Shifts in the calendar (Agendado)
  planned: number;
};

export type ExecutionRow = {
  career: string;
  humanCareer: string;
  planned: number;
  actual: number;
};

export type CostStructure = {
  professionalFeesCost: number;
  salaryBasedCost: number;
  totalDirectCost: number;
  retentionRate: number | null;
};

export type CaregiverCostGroup = {
  price: number;
  cost: number;
  totalShifts: number;
  totalPrice: number;
  totalCost: number;
  totalProfit: number;
  margin: number;
};

export type EmploymentContractType = 'tax_bill' | 'contract' | 'without_contract';

export type CaregiverRankingRow = {
  caregiverId: number;
  fullName: string;
  career: string;
  humanCareer: string;
  employmentContractType: EmploymentContractType;
  shiftsCount: number;
  // Present only for users with shifts:read_financial_information
  totalCost?: number;
  costGroups?: CaregiverCostGroup[];
};

export type PatientMetricsSummary = {
  fullName: string;
  dni: string | null;
  groupNames: string[];
  serviceCategoryName: string | null;
  serviceSubcategoryName: string | null;
};

export type PatientMonthlyMetrics = {
  year: number;
  month: number;
  patient: PatientMetricsSummary;
  therapeuticLoad: TherapeuticLoadRow[] | null;
  execution: ExecutionRow[];
  costs: CostStructure | null;
  caregiverRanking: CaregiverRankingRow[];
};

export const patientMonthlyMetricsApi = {
  show(patientId: number, queryParams?: string): Promise<PatientMonthlyMetrics> {
    return api({
      method: 'get',
      url: `/api/internal/patients/${patientId}/monthly_metrics?${queryParams}`,
    }).then(response => response.data as PatientMonthlyMetrics);
  },
};
